import axios from "axios";

const postsEndPoint = `${BJZM_DATA.site_url}/wp-json/wp/v2/posts`;

class AppWebApiUtilities {

    constructor( args ) {
        this.args = args;
    }

    api(endPoint, params = null) {
        return new Promise((resolve, reject) => {
            axios.get(endPoint, {params: params}).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            }); 
        });
    }

    getPosts(params) {

        this.api(postsEndPoint, params).then((response)=>{
            const posts = response;
            this.args.callBack(posts);
        });
        return true;
    }

}

module.exports = AppWebApiUtilities;










